export * as Api from './api';
export * as Schema from './schema';

export enum InvestorType {
  EverydayInvestor = 'EVERYDAY_INVESTOR',
  SophisticatedInvestor = 'SOPHISTICATED_INVESTOR',
  HighNetWorthInvestor = 'HIGH_NET_WORTH_INVESTOR',
  ProfessionalClient = 'PROFESSIONAL_CLIENT',
  Advised = 'ADVISED',
  ClassificationSkipped = 'CLASSIFICATION_SKIPPED',
}

export enum AccountType {
  Individual = 'INDIVIDUAL',
  LegalEntity = 'LEGAL_ENTITY',
}

export enum IncomeSource {
  EmploymentIncome = 'EMPLOYMENT_INCOME',
  PensionsAndRetirementFunds = 'PENSIONS_AND_RETIREMENT_FUNDS',
  LegalSettlements = 'LEGAL_SETTLEMENTS',
  BusinessProfits = 'BUSINESS_PROFITS',
  InvestmentsAndSavings = 'INVESTMENTS_AND_SAVINGS',
  Inheritance = 'INHERITANCE',
  SaleOfAssets = 'SALE_OF_ASSETS',
  Gifts = 'GIFTS',
}

export enum InvestorCustomTagCategory {
  InvestorGroup = 'investor_group',
  Source = 'source',
  InternalContact = 'internal_contact',
  Other = 'other',
}

export enum InvestorRealm {
  Eis = 'eisInvestor',
  Lp = 'lpInvestor',
}
